export default {
  IdentityCodeValidFunction: function (code) {
    var city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 "
    };
    var tip = "";
    var pass = true;//pass  是否为正确的18位身份证号码

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
      tip = "身份证号格式错误";
      pass = false;
    }

    else if (!city[code.substr(0, 2)]) {
      tip = "地址编码错误";
      pass = false;
    }
    else {
      //18位身份证需要验证最后一位校验位
      if (code.length == 18) {
        code = code.split('');
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (parity[sum % 11] != code[17]) {
          tip = "校验位错误";
          pass = false;
        }
      }
    }
//        if(!pass)
    return pass;
  },//校验身份证号码

//电话号码验证
  phoneRegFunction: function (code) {
    return /^1[2,3,4,5,6,7,8,9]\d{9}$/.test(code)
  },

//中文名字验证
  isChineseName: function (name) {
    return /[a-zA-Z\u4E00-\u9FA5]+$/.test(name)
  },

//加法
  accAdd: function (num1, num2) {
    num1 = Number(num1);
    num2 = Number(num2);
    var dec1, dec2, times;
    try {
      dec1 = this.countDecimals(num1) + 1;
    } catch (e) {
      dec1 = 0;
    }
    try {
      dec2 = this.countDecimals(num2) + 1;
    } catch (e) {
      dec2 = 0;
    }
    times = Math.pow(10, Math.max(dec1, dec2));
    // var result = (num1 * times + num2 * times) / times;
    var result = (this.accMul(num1, times) + this.accMul(num2, times)) / times;
    return this.getCorrectResult("add", num1, num2, result);
    // return result;
  },

//减法
  accSub: function (num1, num2) {
    num1 = Number(num1);
    num2 = Number(num2);
    var dec1, dec2, times;
    try {
      dec1 = this.countDecimals(num1) + 1;
    } catch (e) {
      dec1 = 0;
    }
    try {
      dec2 = this.countDecimals(num2) + 1;
    } catch (e) {
      dec2 = 0;
    }
    times = Math.pow(10, Math.max(dec1, dec2));
    // var result = Number(((num1 * times - num2 * times) / times);
    var result = Number((this.accMul(num1, times) - this.accMul(num2, times)) / times);
    return this.getCorrectResult("sub", num1, num2, result);
    // return result;
  },

//除法
  accDiv: function (num1, num2) {
    num1 = Number(num1);
    num2 = Number(num2);
    var t1 = 0, t2 = 0, dec1, dec2;
    try {
      t1 = this.countDecimals(num1);
    } catch (e) {
    }
    try {
      t2 = this.countDecimals(num2);
    } catch (e) {
    }
    dec1 = this.convertToInt(num1);
    dec2 = this.convertToInt(num2);
    var result = this.accMul((dec1 / dec2), Math.pow(10, t2 - t1));
    return this.getCorrectResult("div", num1, num2, result);
    // return result;
  },

//乘法
  accMul: function (num1, num2) {
    num1 = Number(num1);
    num2 = Number(num2);
    var times = 0, s1 = num1.toString(), s2 = num2.toString();
    try {
      times += this.countDecimals(s1);
    } catch (e) {
    }
    try {
      times += this.countDecimals(s2);
    } catch (e) {
    }
    var result = this.convertToInt(s1) * this.convertToInt(s2) / Math.pow(10, times);
    return this.getCorrectResult("mul", num1, num2, result);
    // return result;
  },


//计算小数位的长度
  countDecimals: function (num) {
    var len = 0;
    try {
      num = Number(num);
      var str = num.toString().toUpperCase();
      if (str.split('E').length === 2) { // scientific notation
        var isDecimal = false;
        if (str.split('.').length === 2) {
          str = str.split('.')[1];
          if (parseInt(str.split('E')[0]) !== 0) {
            isDecimal = true;
          }
        }
        let x = str.split('E');
        if (isDecimal) {
          len = x[0].length;
        }
        len -= parseInt(x[1]);
      } else if (str.split('.').length === 2) { // decimal
        if (parseInt(str.split('.')[1]) !== 0) {
          len = str.split('.')[1].length;
        }
      }
    } catch (e) {
      throw e;
    } finally {
      if (isNaN(len) || len < 0) {
        len = 0;
      }
      return len;
    }
  },

//将小数转成整数
  convertToInt: function (num) {
    num = Number(num);
    var newNum = num;
    var times = this.countDecimals(num);
    var temp_num = num.toString().toUpperCase();
    if (temp_num.split('E').length === 2) {
      newNum = Math.round(num * Math.pow(10, times));
    } else {
      newNum = Number(temp_num.replace(".", ""));
    }
    return newNum;
  },

//确认我们的计算结果无误，以防万一
  getCorrectResult: function (type, num1, num2, result) {
    var temp_result = 0;
    switch (type) {
      case "add":
        temp_result = num1 + num2;
        break;
      case "sub":
        temp_result = num1 - num2;
        break;
      case "div":
        temp_result = num1 / num2;
        break;
      case "mul":
        temp_result = num1 * num2;
        break;
    }
    if (Math.abs(result - temp_result) > 1) {
      return temp_result;
    }
    return result;
  },

//获取年月 yyyyM
  getNowyyyyM: function (type) {
    var myDate = new Date();
    var year = myDate.getFullYear(); //获取完整的年份(4位,1970-????
    var moon = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    switch (type) {
      case 1:
        return year.toString() + moon
        break;
      case 2:
        return year + '年' + moon + '月'
      case 3:
        return year + '-' + moon
        break;
      default:
        return "请传获取年月的类型:1:yyyyM、2:yyyy年M月、3:yyyy-M"
    }
  },
//获取年月 yyyyMM
  getNowyyyyMM: function (type) {
    var myDate = new Date();
    var year = myDate.getFullYear(); //获取完整的年份(4位,1970-????
    var moon = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    if (moon < 10) {
      moon = "0" + "" + moon
    } else {
      moon = moon;
    }
    switch (type) {
      case 1:
        return year.toString() + moon
        break;
      case 2:
        return year + '年' + moon + '月'
      case 3:
        return year + '-' + moon
        break;
      default:
        return "请传获取年月的类型:1:yyyyMM、2:yyyy年MM月、3:yyyy-MM"
    }
  },
  getNowyyyyMMdd: function (type) {
    var myDate = new Date();
    var year = myDate.getFullYear(); //获取完整的年份(4位,1970-????
    var moon = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    var day = myDate.getDate(); //获取当前月份(0-11,0代表1月)
    if (moon < 10) {
      moon = "0" + "" + moon
    } else {
      moon = moon;
    }
    switch (type) {
      case 1:
        return year.toString() + moon + day
        break;
      case 2:
        return year + '年' + moon + '月' +day+'日'
      case 3:
        return year + '-' + moon + '-' +day
        break;
      default:
        return "请传获取年月的类型:1:yyyyMM、2:yyyy年MM月、3:yyyy-MM"
    }
  },
  getYear(){
    var myDate = new Date();
    var year = myDate.getFullYear();
    return year //获取完整的年份(4位,1970-????
  },

  //四舍五入保留小数位数操作函数 num需要操作的数 n需要保留的位数
  toFixed(num,n){
    var f = parseFloat(num);
    if(isNaN(f)){
      return false;
    }
    f = Math.round(num*Math.pow(10, n))/Math.pow(10, n); // n 幂
    var s = f.toString();
    var rs = s.indexOf('.');
    //判定如果是整数，增加小数点再补0
    if(rs < 0){
      rs = s.length;
      s += '.';
    }
    while(s.length <= rs + n){
      s += '0';
    }
    return s;
  },
  //时间戳转正常时间 timeStamp为时间戳 n为10的次方 若timeStamp为毫秒 则n为0  若timeStamp的单位是秒 则n为3  10的三次方=1000
  unixTimestamp(timeStamp,n){
    var unixTimestamp = new Date(timeStamp * Math.pow(10, n))
    commonTime = unixTimestamp.toLocaleString();
    return commonTime;
  },

  //数字转中文大写金额
  numberToChinese(num) {
    if (num === '' || num === null || num === undefined || isNaN(num)) {
      return '';
    }

    // 转换为数字并保留两位小数
    num = parseFloat(num).toFixed(2);

    // 中文数字
    const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    // 基本单位
    const cnIntRadice = ['', '拾', '佰', '仟'];
    // 对应整数部分扩展单位
    const cnIntUnits = ['', '万', '亿', '兆'];
    // 对应小数部分单位
    const cnDecUnits = ['角', '分'];
    // 最大处理的数字
    const maxNum = 999999999999999.99;

    if (num >= maxNum) {
      return '超出最大处理数字';
    }

    if (num == 0) {
      return '人民币零元整';
    }

    // 分离整数和小数部分
    const parts = num.toString().split('.');
    const integerNum = parts[0];
    const decimalNum = parts[1] || '00';

    let result = '人民币';

    // 转换整数部分
    if (parseInt(integerNum, 10) > 0) {
      result = this.convertIntegerPart(integerNum, cnNums, cnIntRadice, cnIntUnits);
    } else {
      // 整数部分为0时，添加"零"
      result = cnNums[0];
    }

    // 添加"元"
    result += '元';

    // 转换小数部分
    const decimalPart = this.convertDecimalPart(decimalNum, cnNums, cnDecUnits);

    if (decimalPart) {
      result += decimalPart;
    } else {
      result += '整';
    }

    return result;
  },

  // 转换整数部分
  convertIntegerPart(integerStr, cnNums, cnIntRadice, cnIntUnits) {
    let result = '';
    const len = integerStr.length;
    let zeroFlag = false; // 标记是否需要添加零

    for (let i = 0; i < len; i++) {
      const digit = parseInt(integerStr[i]);
      const pos = len - i - 1; // 当前位置
      const unitPos = Math.floor(pos / 4); // 万、亿等大单位位置
      const innerPos = pos % 4; // 在当前大单位内的位置

      if (digit === 0) {
        // 当前位是0
        if (innerPos === 0 && result !== '') {
          // 万位、亿位等，且不是开头
          result += cnIntUnits[unitPos];
        }
        zeroFlag = true;
      } else {
        // 当前位不是0
        if (zeroFlag && result !== '') {
          // 前面有0，需要添加"零"
          result += cnNums[0];
        }
        result += cnNums[digit] + cnIntRadice[innerPos];

        if (innerPos === 0) {
          // 万位、亿位等
          result += cnIntUnits[unitPos];
        }
        zeroFlag = false;
      }
    }

    return result;
  },

  // 转换小数部分
  convertDecimalPart(decimalStr, cnNums, cnDecUnits) {
    let result = '';

    // 处理角（十分位）
    const jiao = parseInt(decimalStr[0]);
    if (jiao > 0) {
      result += cnNums[jiao] + cnDecUnits[0];
    }

    // 处理分（百分位）
    const fen = parseInt(decimalStr[1]);
    if (fen > 0) {
      if (jiao === 0 && result === '') {
        // 如果角为0但分不为0，需要加"零"
        result += cnNums[0];
      }
      result += cnNums[fen] + cnDecUnits[1];
    }

    return result;
  },

  GetDateDiff(startTime, endTime, diffType) {
    //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
    startTime = startTime.replace(/\-/g, "/");
    endTime = endTime.replace(/\-/g, "/");

    //将计算间隔类性字符转换为小写
    diffType = diffType.toLowerCase();
    var sTime = new Date(startTime);      //开始时间
    var eTime = new Date(endTime);  //结束时间
    //作为除数的数字
    var divNum = 1;
    switch (diffType) {
        case "second":
            divNum = 1000;
            break;
        case "minute":
            divNum = 1000 * 60;
            break;
      case "hour":
        divNum = 1000 * 3600;
        break;
      case "day":
        divNum = 1000 * 3600 * 24;
        break;
      default:
        break;
    }
    return parseInt((sTime.getTime() - eTime.getTime()) / parseInt(divNum));
  },

  toggleSensitiveData(data) {
    if (data.length === 0) return data;
    data.forEach(item => {
      for (const key in item) {
        if (item[key] !== null) {
          item[key] = '*'.repeat(String(item[key]).length);
        }
      }
    });
    return data;
  }

}







//////////////////
// WEBPACK FOOTER
// ./static/js/utils.js
// module id = crB9
// module chunks = 563